function moveArrayElementsToBeginning(source, ...elements) {
    const elementSet = new Set(elements);
    const result = [];
    for (const item of elements){
        if (elementSet.has(item)) {
            result.push(item);
        }
    }
    for (const item of source){
        if (!elementSet.has(item)) {
            result.push(item);
        }
    }
    return result;
}
export { moveArrayElementsToBeginning };
